var _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.631,25.12v-8.239c0-1.249-.666-2.403-1.748-3.027l-7.136-4.12c-.541-.312-1.144-.468-1.748-.468s-1.207.156-1.748.468l-7.136,4.12c-1.082.624-1.748,1.778-1.748,3.027v8.239c0,1.249.666,2.403,1.748,3.027l7.136,4.12c1.082.624,2.414.624,3.496,0l7.136-4.12c1.082-.624,1.748-1.778,1.748-3.027Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 9.265,
    x2: 21,
    y2: 21
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.837,
    y1: 26.868,
    x2: 21,
    y2: 21
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 31.163,
    y2: 26.868
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDefault);
export default __webpack_public_path__ + "static/media/indoor-default.e2d851cd97fba2617ea51436c18cf8f9.svg";
export { ForwardRef as ReactComponent };